// Breadcrumbs.js
import React from 'react';
import { Breadcrumbs, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Breadcrumb = ({ paths }) => {
  return (
    <Breadcrumbs aria-label="breadcrumb" separator="›">
      {paths.map((path, index) => (
        <Link
          key={index}
          color="inherit"
          component={RouterLink}
          to={path.link}
        >
          {path.label}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
